import { render, staticRenderFns } from "./file-library.vue?vue&type=template&id=2ade4e43&scoped=true&"
import script from "./file-library.vue?vue&type=script&lang=js&"
export * from "./file-library.vue?vue&type=script&lang=js&"
import style0 from "./file-library.vue?vue&type=style&index=0&id=2ade4e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade4e43",
  null
  
)

export default component.exports